module.exports = __webpack_public_path__ + "static/media/facebook.73caaa01.svg";